import React from "react";

const PrimaryLoader = () => {
  return (
    <div className="center-alignment py-5 w-100">
      <div className="primary-loader"></div>
    </div>
  );
};

export default PrimaryLoader;
